var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"videoPlayer",staticStyle:{"border-radius":"10px"},attrs:{"controls":"","width":"100%","height":"auto","poster":_vm.poster}})])}
var staticRenderFns = []

export { render, staticRenderFns }